module.exports = __webpack_public_path__ + "cd455783/img/arrow-share-icon.00a12c29.svg";